import React from 'react';
import ReactDOM from 'react-dom';

export const printComponent = (Component, props) => {
  const printWindow = window.open('', '_blank');
  
  if (!printWindow) {
    alert('Please allow pop-ups to print this document.');
    return;
  }

  // Add necessary styles
  printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <style>
          @media print {
            body {
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
          }
          @page {
            size: auto;
            margin: 20mm;
          }
        </style>
      </head>
      <body>
        <div id="print-root"></div>
      </body>
    </html>
  `);

  // Render the component in the new window
  ReactDOM.render(
    <Component {...props} />,
    printWindow.document.getElementById('print-root')
  );

  // Wait for styles to load
  printWindow.document.close();
  
  printWindow.onload = () => {
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.onafterprint = () => printWindow.close();
    }, 1000);
  };
}; 